import {
  Button,
  Container,
  Col,
  Form,
  Row,
  OverlayTrigger,
  Tooltip,
  Popover,
} from "react-bootstrap";
import React from "react";
import "./CSS/ActionComp.css";
import { BsPlusLg, BsSearch } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { searchActions } from "../../store/grid-slice";
import downloadicon from "../../icons/downloadIcon.svg";

const ActionComp = (props) => {
  const dispatch = useDispatch();
  const searchReText = useSelector((state) => state.grid.searchQuery);
  let displayDownload = props.hasOwnProperty("export") ? props.export : true;
  // if (props.hasOwnProperty("export")) displayDownload = props.export;

  console.log(
    "displayDownload :: ",
    displayDownload,
    "\t props.export ::",
    props.export,
  );

  const onFilterTextChange = (e) => {
    dispatch(searchActions.setSearch(e.target.value));
  };

  return (
    <Container fluid className="action-comp-container">
      <div
        className={`action-main ${props.instructionText ? "has-instruction" : ""}`}
      >
        {props.instructionText && (
          <div
            className="instruction-label"
            style={{
              marginBottom: "8px",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            {props.instructionText}
          </div>
        )}
        {props.handleAdd && (
          <Col>
            <div className="parent-add-btn">
              <Button className="add-btn" onClick={props.handleAdd}>
                <BsPlusLg color="#FFFFFF" size={20} className="plus-icon" />
                <span className="add-btn-label">{props.label}</span>
              </Button>
            </div>
          </Col>
        )}
        {props.handleAdd2 && (
          <Col>
            <div className="parent-add-btn">
              <Button className="add-btn" onClick={props.handleAdd2}>
                <BsPlusLg color="#FFFFFF" size={20} className="plus-icon" />
                <span className="add-btn-label">{props.label2}</span>
              </Button>
            </div>
          </Col>
        )}
        {props.handleDueDate && (
          <Col lg={2} md={6} xs={12}>
            <div className="parent-add-btn">
              <Button className="add-btn" onClick={props.handleDueDate}>
                <BsPlusLg color="#FFFFFF" size={20} className="plus-icon" />
                <span className="add-btn-label">{props.labelDueDate}</span>
              </Button>
            </div>
          </Col>
        )}
        {props.handleAdd3 && (
          <Col lg={2} md={6} xs={12}>
            <div className="parent-add-btn">
              <Button className="add-btn" onClick={props.handleAdd3}>
                <BsPlusLg color="#FFFFFF" size={20} className="plus-icon" />
                <span className="add-btn-label">{props.label3}</span>
              </Button>
            </div>
          </Col>
        )}
        {/* <Col lg={2} md={2} xs={12}>&nbsp;
          {props.columnList &&
            <OverlayTrigger trigger="click" placement="bottom-start" rootClose overlay={
              <Popover aria-labelledby="contained-modal-title-vcenter">
                <Container className="column-grid-container">
                  {props.columnList?.map((header, index) => (
                    header.headerName && <Row key={index}>
                      <Form.Group>
                        <Form.Check type="checkbox"
                          onChange={(e) => handleColumnChooser(e, index)}
                          checked={!header.hide}
                          label={header.headerName} />
                      </Form.Group>
                    </Row>
                  ))}
                </Container>
              </Popover>}>
              <div className='rightAlignedButton'>
                <OverlayTrigger overlay={<Tooltip>Column Chooser</Tooltip>}>
                  <img
                    src={columnGridIconGray}
                    className="action-icon d-none d-md-block d-lg-block"
                  />
                </OverlayTrigger>
              </div>
            </OverlayTrigger>
          }
        </Col> */}
        <Col lg={3} md={4} xs={12}>
          <div className="parent-search-download">
            <div className="records-search">
              <BsSearch size={16} color="#707070" />
              <input
                type="text"
                placeholder="Search here..."
                className="records-search-input"
                onChange={onFilterTextChange}
                value={searchReText}
              />
            </div>
            {console.log(
              "displayDownload :: ",
              displayDownload,
              "\t props.export ::",
              props.export,
            )}
            {displayDownload &&
              props.label !== "Add New Disposal Intimation" &&
              props.label !== "Add New Enquiry/Tender" &&
              props.label !== "Maintain Bid" &&
              props.label !== "Update Sales Order" && (
                <img
                  src={downloadicon}
                  alt="downloading"
                  className="icon-border"
                  onClick={props.exportEvent}
                />
              )}
          </div>
        </Col>
      </div>
    </Container>
  );
};

export default ActionComp;
